import { useMutation, useQuery } from "@tanstack/react-query";

import axiosInstance from "./axios";
import { PaginationResponse } from "../types/commonTypes";

export type StockTransferPayload = {
  productId: number;
  quantity: number;
  unit: string;
  conversionToBaseUnit: number;
  baseQuantity: number;
  fromBranchId: number;
  toBranchId: number;
  transferDate: string;
};

export type StockTransferHistoryParams = {
  productId?: number;
  fromBranchId?: number;
  pageNo: number;
  pageSize: number;
};

export type StockTransferHistoryItem = {
  id?: number | string;
  productId?: number;
  productName?: string;
  quantity?: number;
  qty?: number;
  fromBranchId?: number;
  fromBranchName?: string;
  toBranchId?: number;
  toBranchName?: string;
  warehouseName?: string;
  transferDate?: string;
  createdAt?: string;
};

type StockTransferHistoryResponse =
  | PaginationResponse<StockTransferHistoryItem>
  | {
      content?: StockTransferHistoryItem[];
      stockTransferResponseList?: StockTransferHistoryItem[];
      transferHistory?: StockTransferHistoryItem[];
    };

export const useCreateStockTransfer = () => {
  return useMutation({
    mutationKey: ["useCreateStockTransfer"],
    mutationFn: async (postData: StockTransferPayload) => {
      const { data } = await axiosInstance.post("/stock-transfer", postData);
      return data;
    },
  });
};

export const useGetStockTransferHistory = (
  params: StockTransferHistoryParams,
) => {
  return useQuery({
    queryKey: ["useGetStockTransferHistory", params],
    queryFn: async () => {
      const { data } = await axiosInstance.get("/stock-transfer/history", {
        params,
      });
      return data as StockTransferHistoryResponse;
    },
    enabled: Boolean(params.productId && params.fromBranchId),
  });
};
